export const voiceSettingsStrings: Record<string, [string, string, string]> = {
  'voiceInteraction.bookingHint': [
    '購票請告訴我：日期、成人人數、兒童人數。',
    'To book, tell me the date and the numbers of adults and children.',
    '購入する日付、大人と子供の人数を教えてください。',
  ],
  'voiceInteraction.bookingExample': [
    '例如：「今天，兩個大人、一個小孩。」也可以先說「我要訂票」，我會一步步詢問您。',
    'For example: “Today, two adults and one child.” Or say “I want to book tickets” and I will guide you.',
    '例：「今日、大人2人、子供1人」。または「チケットを買いたい」と話しかけてください。',
  ],
  'voiceInteraction.manualRequired': [
    '點擊再次說話',
    'Microphone off. Tap the microphone to ask another question.',
    '収音を停止しました。続けるにはマイクをタップしてください。',
  ],
  'voiceInteraction.answerWithoutCapture': [
    '點擊再次說話',
    'Microphone off. Preparing or playing the answer.',
    '収音停止中。回答を準備・再生しています。',
  ],
  'voiceSettings.title': ['語音設定', 'Voice settings', '音声設定'],
  'voiceSettings.mode': ['使用模式', 'Voice mode', '音声モード'],
  'voiceSettings.local': ['本地辨識（目前版本）', 'Local recognition', 'ローカル音声認識'],
  'voiceSettings.realtime': [
    'OpenAI Realtime 即時對話',
    'OpenAI Realtime conversation',
    'OpenAI Realtime 会話',
  ],
  'voiceSettings.activation': ['開始收音方式', 'Start listening', '音声入力の開始'],
  'voiceSettings.showTranscript': [
    '顯示「您說」文字',
    'Show “You said” text',
    '「認識した内容」を表示',
  ],
  'voiceSettings.showTranscriptHint': [
    '關閉後隱藏您說的文字，收音、辨識與 AI 回答照常運作。',
    'When off, hides your transcript. Listening, recognition and AI replies continue as usual.',
    'オフにすると認識した文字を非表示にします。収音・認識・AI の回答は通常どおり動作します。',
  ],
  'voiceSettings.audioOutput': [
    '播放 AI 語音回覆',
    'Play AI spoken replies',
    'AI の音声回答を再生',
  ],
  'voiceSettings.audioOutputHint': [
    '關閉後仍可用麥克風提問，只顯示文字回答，不產生回答語音。',
    'When off, you can still speak. Replies are text only, without generated reply audio.',
    'オフでもマイクで質問できます。回答音声を生成せず、文字のみ表示します。',
  ],
  'voiceSettings.voice': ['回覆聲音', 'Reply voice', '回答の声'],
  'voiceSettings.voiceHint': [
    '建議先試聽 marin 或 cedar。儲存後於下一次對話生效，不中斷目前對話。',
    'Try marin or cedar first. Saved choices apply to the next conversation without interrupting the current one.',
    'marin または cedar をお試しください。保存後、現在の会話を中断せず、次の会話から適用します。',
  ],
  'voiceSettings.preview': ['試聽所選聲音', 'Preview selected voice', '選択した声を試聴'],
  'voiceSettings.previewStop': ['停止試聽', 'Stop preview', '試聴を停止'],
  'voiceSettings.previewHint': [
    '試聽會播放一段 AI 語音，使用目前選擇的聲音且不開啟麥克風；會使用 OpenAI API 額度。',
    'Preview plays a short AI sample in the selected voice without using the microphone. OpenAI API usage applies.',
    '選択した声の短い AI 音声を再生します。マイクは使用しません。OpenAI API の利用料が発生します。',
  ],
  'voiceSettings.click': ['點擊開始', 'Start on tap', 'タップで開始'],
  'voiceSettings.automatic': [
    '進入語音頁自動開始',
    'Automatically on the voice page',
    '音声ページで自動開始',
  ],
  'voiceSettings.activationHint': [
    '自動模式在進入語音頁後開始；本地版回答後繼續收音。取消或逾時後需點擊重新開始。鏡頭偵測仍先顯示邀請。',
    'Automatic mode starts on the voice page; local recognition listens again after each answer. Tap to restart after cancellation or timeout. Camera detection still shows an invitation first.',
    '自動モードは音声ページで開始し、ローカル認識は回答後に再開します。停止・タイムアウト後はタップで再開してください。カメラ検出時は先に案内を表示します。',
  ],
  'voiceSettings.threshold': ['VAD 語音門檻', 'VAD speech threshold', 'VAD 音声しきい値'],
  'voiceSettings.thresholdHint': [
    '0.1～0.9；越低越容易觸發，越高越能排除背景聲。兩種模式的數值不代表相同靈敏度。',
    '0.1–0.9: lower detects quieter speech; higher rejects more background noise. Values are not equivalent across modes.',
    '0.1～0.9：低いほど小さな声を検出し、高いほど雑音を除外します。モード間で感度は異なります。',
  ],
  'voiceSettings.silence': [
    '句尾靜音時間（毫秒）',
    'End-of-turn silence (ms)',
    '文末の無音時間（ミリ秒）',
  ],
  'voiceSettings.minSpeech': [
    '最短有效語音（毫秒）',
    'Minimum speech (ms)',
    '最短音声時間（ミリ秒）',
  ],
  'voiceSettings.prefix': [
    '保留語音前段（毫秒）',
    'Speech prefix padding (ms)',
    '音声前の保持時間（ミリ秒）',
  ],
  'voiceSettings.save': ['儲存語音設定', 'Save voice settings', '音声設定を保存'],
  'voiceSettings.defaults': ['還原預設值', 'Restore defaults', '初期値に戻す'],
  'voiceSettings.saved': [
    '已儲存，下一次語音互動生效。',
    'Saved for the next voice interaction.',
    '保存しました。次の音声操作から適用されます。',
  ],
  'voiceSettings.failed': [
    '無法儲存，請檢查數值與瀏覽器儲存權限。',
    'Cannot save. Check values and browser storage permissions.',
    '保存できません。値とブラウザーの保存権限を確認してください。',
  ],
  'voiceSettings.test': ['測試所選模式連線', 'Test selected mode', '選択モードの接続テスト'],
  'voiceSettings.ready': [
    '設定與服務連線正常；實際麥克風與喇叭請於語音頁試用。',
    'Configuration and service checks passed. Test the microphone and speaker on the voice page.',
    '設定とサービス接続を確認しました。マイクとスピーカーは音声ページでお試しください。',
  ],
  'voiceSettings.privacy': [
    '本地版只送出辨識文字；Realtime 會傳送聲音至 OpenAI，可選擇是否播放 AI 語音。首次使用須允許麥克風；若瀏覽器阻擋自動啟動或播放，請點擊開始。',
    'Local mode sends recognized text; Realtime sends audio to OpenAI, with optional AI-generated spoken replies. Allow microphone access on first use. Tap Start if your browser blocks automatic capture or playback.',
    'ローカルモードは認識した文字を送信し、Realtime は音声を OpenAI に送信します。AI 音声の再生は選択できます。初回はマイクを許可してください。自動開始・再生が制限される場合は開始をタップしてください。',
  ],
  'voiceRealtime.listening': [
    '正在聆聽，可直接繼續說話',
    'Listening — you can keep talking',
    '聞いています。そのままお話しください',
  ],
  'voiceRealtime.speaking': [
    'AI 正在回答，可開口打斷',
    'AI is speaking — you may interrupt',
    'AI が回答中です。話しかけて中断できます',
  ],
  'voiceRealtime.stop': ['結束語音對話', 'End voice conversation', '音声会話を終了'],
  'voiceResult.error.REALTIME_UNAVAILABLE': [
    '即時語音無法連線，請重試或改用手動操作。',
    'Realtime is unavailable. Retry or use the touchscreen.',
    '音声接続ができません。再試行するか画面で操作してください。',
  ],
  'voiceResult.error.REALTIME_ENDPOINT_UNSUPPORTED': [
    'Realtime 需要 CMS 設定 OpenAI 官方端點。',
    'Realtime requires the official OpenAI endpoint in CMS.',
    'Realtime は CMS に OpenAI 公式エンドポイントの設定が必要です。',
  ],
  'voiceResult.error.REALTIME_PLAYBACK_BLOCKED': [
    '瀏覽器尚未允許聲音播放，請點擊麥克風重新開始。',
    'Audio playback was blocked. Tap the microphone to restart.',
    '音声再生が制限されています。マイクをタップして再開してください。',
  ],
  'voiceResult.error.REALTIME_TIMEOUT': [
    '對話已因逾時停止，點擊麥克風可重新開始。',
    'The conversation timed out. Tap the microphone to restart.',
    'タイムアウトしました。マイクをタップして再開してください。',
  ],
};
